module.exports = __webpack_public_path__ + "h5/img/underwriting-announcement.5e4e0358.webp";